interface Ide400 {
  serie: string;
  nNF: string;
  dhEmi: string;
  tpNF: string;
  tpAmb: string;
  dhSaiEnt: string;
}

interface Emit400 {
  xNome: string;
  xFant: string;
  CNPJ: string;
  CPF: string;
  CRT: string;
  IE: string;
  enderEmit: {
    xLgr: string;
    nro: string;
    xBairro: string;
    cMun: string;
    xMun: string;
    UF: string;
    CEP: string;
    cPais: string;
    xPais: string;
    fone: string;
  };
  email: string;
}

interface Dest400 {
  // dados pessoais
  xNome: string;

  // dados empresa
  CNPJ: string;
  IE: string;
  IM: string;
  indIEDest: string;
  CPF: string;

  // dados endereço
  enderDest: {
    xLgr: string;
    xMun: string;
    UF: string;
    xBairro: string;
    nro: string;
    xCpl: string;
    cMun: string;
    CEP: string;
    cPais: string;
    xPais: string;
  };
}

interface Total400 {
  vBC: string;
  vICMS: string;
  vNF: string;
  vOutro: string;
  vDesc: string;
  vFrete: string;
  vTotTrib: string;
}

export interface ProdDet {
  cProd: string;
  cEAN: string;
  xProd: string;
  NCM: string;
  CFOP: string;
  uCom: string;
  qCom: string;
  vUnCom: string;
  vProd: string;
  cEANTrib: string;
  uTrib: string;
  qTrib: string;
  vUnTrib: string;
  indTot: string;
}

export interface ImpostoDet {
  vTotTrib: string;
  ICMS: {
    ICMS00: {
      orig: string;
      CST: string;
      modBC: string;
      vBC: string;
      pICMS: string;
      vICMS: string;
    };
    ICMS10: {
      orig: string;
      CST: string;
      modBC: string;
      vBC: string;
      pICMS: string;
      vICMS: string;
      modBCST: string;
      pMVAST: string;
      vBCST: string;
      pICMSST: string;
      vICMSST: string;
    };
    ICMS20: {
      orig: string;
      CST: string;
      modBC: string;
      pRedBC: string;
      vBC: string;
      pICMS: string;
      vICMS: string;
    };
    ICMS30: {
      orig: string;
      CST: string;
      modBCST: string;
      pMVAST: string;
      vBCST: string;
      pICMSST: string;
      vICMSST: string;
    };
    ICMS51: {
      orig: string;
      CST: string;
      modBC: string;
      pRedBC: string;
      vBC: string;
      pICMS: string;
      vICMSOp: string;
      pDif: string;
      vICMSDif: string;
    };
    ICMS70: {
      orig: string;
      CST: string;
      modBC: string;
      pRedBC: string;
      vBC: string;
      pICMS: string;
      vICMS: string;
      modBCST: string;
      pMVAST: string;
      vBCST: string;
      pICMSST: string;
      vICMSST: string;
    };
  };
  IPI: {
    cEnq: string;
    IPINT: {
      CST: string;
    };
  };
  PIS: {
    PISAliq: {
      CST: string;
      vBC: string;
      pPIS: string;
      vPIS: string;
    };
  };
  COFINS: {
    COFINSAliq: {
      CST: string;
      vBC: string;
      pCOFINS: string;
      vCOFINS: string;
    };
  };
}

export interface Det400 {
  nItem: string;
  prod: ProdDet;
  imposto: ImpostoDet;
  multiplicar: boolean;
  dividir: boolean;
}

export interface DetPag400 {
  indPag: string;
  tPag: string;
  vPag: string;
}

export interface Pag400 {
  detPag: DetPag400[];
  vTroco: string;
}

export interface InfNFeSupl400 {
  qrCode: string;
  urlChave: string;
}

export interface Signature400 {}

export interface InfProt400{
  tpAmb: string;
  verAplic: string;
  chNFe: string;
  dhRecbto: string;
  nProt: string;
  digVal: string;
  cStat: string;
  xMotivo: string;
}

export class NFe4_00 {
  public Id: string;
  public ide: Ide400;
  public emit: Emit400;
  public dest?: Dest400;
  public det: Det400[];
  public total: Total400;
  public pag: Pag400;
  public infNfeSupl: InfNFeSupl400;
  public signature: Signature400;

  constructor() {
    this.ide = {} as Ide400;
    this.emit = {
      enderEmit: {}
    } as Emit400;
    this.dest = {
      enderDest: {}
    } as Dest400;
    this.total = {} as Total400;
    this.det = [] as Det400[];
    this.pag = {} as Pag400;
    this.infNfeSupl = {} as InfNFeSupl400;
    this.signature = {} as Signature400;
  }
}

export class ProtNFe4_00{
  public infProt: InfProt400;

  constructor(){
    this.infProt = {} as InfProt400;
  }
}
